import { V2_API_PREFIX } from '@constants'

export const API_MESSAGE_TO_ACCOUNTANT_URL = `${V2_API_PREFIX}accounting/company/{company_id}/message-to-accountant/`
export const API_MESSAGE_TO_ACCOUNTANT_TOPICS_URL = `${API_MESSAGE_TO_ACCOUNTANT_URL}topics/`
